import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Collapse,
  Container,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
} from "reactstrap";
import handleNavbarTransparency from "../../helpers/handleNavbarTransparency";
import LandingNavbarTopDropDownMenus from "./LandingNavbarTopDropDownMenus";
import LandingRightSideNavItem from "./LandingRightSideNavItem";
import { topNavbarBreakpoint } from "../../config";
import logo from "../../assets/img/illustrations/sikka-logo-white.png";

const NavbarStandard = ({ isMenuShow,customLogo }) => {
  const [navbarCollapsed, setNavbarCollapsed] = useState(true);
  isMenuShow = `${isMenuShow}` ? isMenuShow : true;
  customLogo = customLogo || logo;
  

  useEffect(() => {
    window.addEventListener("scroll", handleNavbarTransparency);
    return () => window.removeEventListener("scroll", handleNavbarTransparency);
  }, []);

  return (
    <Navbar
      dark
      fixed="top"
      expand={topNavbarBreakpoint}
      className={classNames("navbar-standard navbar-theme", {
        "bg-dark": !navbarCollapsed,
      })}
    >
      <Container>
        <NavbarBrand
          className="text-white"
          tag={Link}
          to={process.env.PUBLIC_URL}
        >
          <img className="mr-2" src={customLogo} alt="Logo" width="150" height="30" />
          {/* SIKKA */}
        </NavbarBrand>
        {isMenuShow && (
          <>
            <NavbarToggler
              onClick={() => setNavbarCollapsed(!navbarCollapsed)}
            />
            <Collapse isOpen={!navbarCollapsed} navbar className="scrollbar">
              <Nav navbar>
                <LandingNavbarTopDropDownMenus
                  setNavbarCollapsed={setNavbarCollapsed}
                />
              </Nav>
              <LandingRightSideNavItem />
            </Collapse>
          </>
        )}
      </Container>
    </Navbar>
  );
};

export default NavbarStandard;
